import { render, staticRenderFns } from "./SearchFrequency.vue?vue&type=template&id=79807866&scoped=true"
import script from "./SearchFrequency.vue?vue&type=script&lang=js"
export * from "./SearchFrequency.vue?vue&type=script&lang=js"
import style0 from "./SearchFrequency.vue?vue&type=style&index=0&id=79807866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79807866",
  null
  
)

export default component.exports